var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41184 5.65967C2.72517 -0.113657 11.2785 -0.10699 12.5852 5.66634C13.3519 9.05301 11.2452 11.9197 9.39854 13.693C8.05854 14.9863 5.93854 14.9863 4.59184 13.693C2.75184 11.9197 0.645171 9.04634 1.41184 5.65967Z",
    stroke: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1687 7.6652L6.1687 8.6652L8.83537 5.99854",
    stroke: "#313131",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/deliveryIcon.4c07bc5a17ef89c55d34f2b289e4f9a4.svg";
export { ForwardRef as ReactComponent };